import { Axios } from 'axios';
import {
  DatabaseAttachableNetworksDto,
  DatabaseAttachNetworkDto,
  DatabaseAttachNetworkResDto,
  DatabaseBackupListDto,
  DatabaseBackupScheduleCreateDto,
  DatabaseBackupToggleDeleteProtectionDto,
  DatabaseCatalogDto, DatabaseChangeAvailabilityDto,
  DatabaseChangeNameDto,
  DatabaseConnectionDto,
  DatabaseCreateDTO, DatabaseCredentialsDto,
  DatabaseListRResponseDTO, DatabaseNetworksDto,
  DatabaseResponseDTO,
  DatabaseScaleDto,
} from 'components/Database/types/dtos';

import apiClient from 'services/api/axios';

class DatabaseService {
  api: Axios;

  constructor(api: Axios) {
    this.api = api;
  }

  getDatabases() {
    return this.api.get<DatabaseListRResponseDTO>('panel/databases');
  }

  getDatabaseById(id: number) {
    return this.api.get<DatabaseResponseDTO>(`panel/databases/${id}`);
  }

  getDatabaseCatalog() {
    return this.api.get<DatabaseCatalogDto>('panel/databases/catalog');
  }

  createDatabase(dto: DatabaseCreateDTO) {
    return this.api.post<DatabaseResponseDTO>('panel/databases', dto);
  }

  changeResources(id: number, dto: DatabaseScaleDto) {
    return this.api.patch(`panel/databases/${id}/resources`, dto);
  }

  changeName(id: number, dto: DatabaseChangeNameDto) {
    return this.api.patch(`panel/databases/${id}/name`, dto);
  }

  changeAvailability(id: number, dto: DatabaseChangeAvailabilityDto) {
    return this.api.patch(`panel/databases/${id}/replicas`, dto);
  }

  toggleDeleteProtection(id: number, dto: DatabaseBackupToggleDeleteProtectionDto) {
    return this.api.patch(`panel/databases/${id}/deletion-protection`, dto);
  }

  deleteDatabase(id: number) {
    return this.api.delete(`panel/databases/${id}`);
  }

  getDatabaseBackups(dbId: number) {
    return this.api.get<DatabaseBackupListDto>(`panel/databases/${dbId}/backups`);
  }

  createDatabaseBackup(dbId: number) {
    return this.api.post(`panel/databases/${dbId}/backup`);
  }

  createDatabaseBackupSchedule(dbId: number, dto: DatabaseBackupScheduleCreateDto) {
    return this.api.post(`panel/databases/${dbId}/backupScheduled`, dto);
  }

  restoreBackup(dbId: number, backupName: string) {
    return this.api.post(`panel/databases/${dbId}/backups/${backupName}/restore`);
  }

  deleteBackup(dbId: number, backupName: string) {
    return this.api.delete(`panel/databases/${dbId}/backups/${backupName}`);
  }

  deleteBackupSchedule(dbId: number, backupName: string) {
    return this.api.post(`panel/databases/${dbId}/backupScheduled/${backupName}`);
  }

  getConnectionParams(dbId: number) {
    return this.api.get<DatabaseConnectionDto>(`panel/databases/${dbId}/connection`);
  }

  getCredentials(dbId: number) {
    return this.api.get<DatabaseCredentialsDto>(`panel/databases/${dbId}/credentials`);
  }

  getDatabaseAttachableNetworks(dbId?: number) {
    return this.api.get<DatabaseAttachableNetworksDto>(`panel/databases/${dbId}/networks/attachable`);
  }

  getAttachableNetworks() {
    return this.api.get<DatabaseAttachableNetworksDto>('panel/databases/networks/attachable');
  }

  getNetworks(dbId: number) {
    return this.api.get<DatabaseNetworksDto>(`panel/databases/${dbId}/networks`);
  }

  attachNetwork(dbId: number, dto: DatabaseAttachNetworkDto) {
    return this.api.post<DatabaseAttachNetworkResDto>(`panel/databases/${dbId}/networks`, dto);
  }

  detachNetwork(dbId: number, netId: number) {
    return this.api.delete<DatabaseCredentialsDto>(`panel/databases/${dbId}/networks/${netId}`);
  }

  resetPassword(dbId: number) {
    return this.api.post(`panel/databases/${dbId}/admin-password/reset`);
  }
}

export default new DatabaseService(apiClient);
